import React, { useState } from "react";
import { useLanguages, LanguageModel } from "../hooks/useLanguages";
import { MenuItem, Menu, IconButton, Stack, Typography, Tooltip } from "@mui/material";
import LanguageIcon from "@mui/icons-material/Language";

const LanguageSelect: React.FC<{ handleLanguageChange: (languageId: string) => void }> = ({ handleLanguageChange }) => {
  const { languages } = useLanguages();
  const [selectedLanguage, setSelectedLanguage] = useState<LanguageModel | null>(null);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelectLanguage = (language: LanguageModel) => {
    setSelectedLanguage(language);
    setAnchorEl(null);
    handleLanguageChange(language.id);
  };

  React.useEffect(() => {
    if (languages && languages.length > 0 && !selectedLanguage) {
      // Find English as default if possible
      const defaultLang = languages.find((l) => l.name.toLowerCase() === "english") ?? languages[0];
      setSelectedLanguage(defaultLang);
      handleLanguageChange(defaultLang.id);
    }
  }, [languages, handleLanguageChange, selectedLanguage]);

  if (!languages || languages.length === 0) {
    return null;
  }

  return (
    <>
      <Tooltip arrow title={selectedLanguage ? `Language: ${selectedLanguage.name}` : "Language"}>
        <IconButton size="small" onClick={handleClick} color="inherit" sx={{ color: "text.secondary" }}>
          <LanguageIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Menu
        id="language-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          list: {
            "aria-labelledby": "language-button",
            role: "listbox",
          },
        }}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        {languages?.map((language) => (
          <MenuItem
            key={language.id}
            onClick={() => handleSelectLanguage(language)}
            selected={selectedLanguage?.id === language.id}
          >
            <Stack direction="row" spacing={1} alignItems="center">
              <Typography variant="body2">{language.name}</Typography>
            </Stack>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LanguageSelect;
